(function (angular) {
  angular.module('xplenty-designer').factory('DesignerAggregateComponent', [
    'DesignerComponent',
    'DesignerSchema',

    function (DesignerComponent, DesignerSchema) {
      function DesignerAggregateComponent() {
        DesignerComponent.apply(this);

        this.fields = [];
      }

      DesignerAggregateComponent.prototype = new DesignerComponent();

      DesignerAggregateComponent.prototype.getData = function () {
        const data = DesignerComponent.prototype.getData.call(this);

        _.extend(data, {
          grouped_fields: this.grouping_type === 'all' ? [] : this.grouped_fields || this.defaults.grouped_fields,
          aggregated_fields: this.aggregated_fields || this.defaults.aggregated_fields,
        });

        if (!this.grouping_type) {
          this.grouping_type = data.grouped_fields.length ? 'group_by' : 'all';
        }

        data.grouping_type = this.grouping_type;

        return data;
      };

      DesignerAggregateComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerComponent.prototype.setFormData.call(this, data);
      };

      DesignerAggregateComponent.prototype.setData = function (data) {
        this.grouped_fields = data.grouped_fields;
        this.aggregated_fields = data.aggregated_fields;
        this.grouping_type = data.grouping_type;

        DesignerComponent.prototype.setData.call(this, data);
      };

      DesignerAggregateComponent.prototype.getSchema = function () {
        const schema = new DesignerSchema();

        schema.id = this.id;
        schema.name = this.name;

        _.each(this.grouped_fields, function (field) {
          schema.fields.push({
            name: field.field_name,
          });
        });

        _.each(this.aggregated_fields, function (field) {
          schema.fields.push({
            name: field.alias,
          });
        });

        return schema;
      };

      return DesignerAggregateComponent;
    },
  ]);
})(window.angular);
